import React,{useState} from 'react'
import Layout from '../../components/Layout/Layout'
import axios from "axios";
import {useNavigate} from 'react-router-dom'
import toast from 'react-hot-toast';
import { SERVER_API } from '../../fileWithConstants';
const AddCategory = () => {
const navigate = useNavigate();
const [name, setName] = useState('');
const [categoryCheck, setCategoryCheck] = useState('');
const [submitting, setSubmitting] = useState(false);
const handleSubmit = async(e)=>{
    e.preventDefault();
    if(!submitting) {
      try {
        const {data} = await axios.post(`${SERVER_API}/api/v1/fabric/add-category`,{name});
        if(data?.success){
          setCategoryCheck('');
          toast.success(data?.message)
          setName("");
        }else{
          setCategoryCheck('Category Already exist');
          toast.error(data?.message)
        }
      } catch (error) {
        console.log(error)
      } finally {
        setSubmitting(false);
      }
    }
}

const cancelHandle = ()=>{
  navigate('/dashboard/category-list');
}

  return (
    <Layout title={'Add Category'}>
     
      <div className='form-container'>
  <form onSubmit={handleSubmit} encType="multipart/form-data" className='form-section'>
      <h4 className='title'>Add Category</h4>
      <div className='form-box'>
      <div className="mb-3">
      <label>Category Name*</label>
          <input type="text" 
          className="form-control"
          value={name}
          name='name'
          onChange={(e)=>setName(e.target.value)}
          required
           />
           <p className='text-danger'>{categoryCheck}</p>
      </div>
      <div className='row'>
      <div className='col-6'><button type="submit" className="btn btn-dark form-control">Add</button></div>
      <div className='col-6'> <button type="button" onClick={cancelHandle} className="btn btn-dark form-control">Back</button></div>
      </div>


      </div>      
      </form>
  </div>
    </Layout>
  )
}

export default AddCategory
